import {
  buildLegacyCustomImageUrl,
  isAbsoluteMediaUrl,
} from '../../../lib/legacyCustomImageUrl';
import { isLegacyCustomImageHash } from '../../../lib/legacyOrgPhotoRef';

function isAbsoluteMediaRef(value: string): boolean {
  return isAbsoluteMediaUrl(value);
}

export type ResolveMediaSrcOptions = {
  diagramId?: string | null;
  region?: string | null;
};

export function resolveMediaSrc(
  mediaRef: string | undefined | null,
  options?: ResolveMediaSrcOptions
): string {
  const trimmed = (mediaRef || '').trim();
  if (!trimmed) return '';
  if (isAbsoluteMediaRef(trimmed)) return trimmed;
  if (isLegacyCustomImageHash(trimmed)) {
    const legacyUrl = buildLegacyCustomImageUrl(trimmed, { region: options?.region });
    if (legacyUrl) return legacyUrl;
  }
  const keyParam = `key=${encodeURIComponent(trimmed)}`;
  const diagramId = (options?.diagramId || '').trim();
  if (!diagramId) {
    return `/api/media/object?${keyParam}`;
  }
  return `/api/media/object?${keyParam}&diagramId=${encodeURIComponent(diagramId)}`;
}
